"use strict";

module.exports = {
  REPORT: 'chrome_reader_mode',
  DASHBOARD: 'dashboard',
  PAGINATED_REPORT: 'dynamic_feed',
  QNA: 'question_answer',
  DEFAULT: 'category'
};